// ThemeSwitcher.jsx
import React from "react";
import { useTheme } from "../../context/ThemeContext";
import DropdownMenu from "./dropdown-menu";
import Button from "./Button";
import { Sun, Moon, Palette } from "lucide-react";

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  const themes = [
    {
      name: "Light",
      value: "theme-light",
      icon: <Sun size={18} className="text-yellow-500" />,
    },
    {
      name: "Dark",
      value: "theme-dark",
      icon: <Moon size={18} className="text-gray-300" />,
    },
    {
      name: "Zen",
      value: "theme-peaceful",
      icon: <Palette size={18} className="text-purple-500" />,
    },
  ];

  return (
    <DropdownMenu
      buttonContent={
        <span className="flex items-center gap-2">
          <Palette size={16} /> Temă
        </span>
      }
    >
      {({ closeMenu }) =>
        themes.map((t) => (
          <Button
            key={t.value}
            variant="ghost"
            onClick={() => {
              setTheme(t.value);
              closeMenu();
            }}
            className={`w-full justify-start gap-2 ${
              theme === t.value
                ? "bg-accent-1/20 font-semibold border border-accent-1"
                : ""
            }`}
          >
            {t.icon} {t.name}
          </Button>
        ))
      }
    </DropdownMenu>
  );
}
